import React, { Component } from 'react';
import {Form, reduxForm, FormSection, SubmissionError} from 'redux-form';
import PropTypes from 'prop-types';
import { intlShape, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { PAGE_NAME } from '../../../../config/DEConstants';
import {FORM_ID} from '../../../../../framework/App/AppConstants';
import CollapsibleAddressFields from '../../../../components/CollapsibleAddressFields/CollapsibleAddressFields';
import UserTitle from '../../../../components/UserTitle/UserTitle';
import FullName from '../../../../../shared-components/NameComponent/FullName/FullName';
import BirthDate from '../../../../components/BirthDate/BirthDate';
import PhoneNumber from '../../../../components/PhoneGroup/PhoneNumber/PhoneNumber';
import AgreeToCheckCreditCheckBox from '../../../../components/AgreeToCheckCreditCheckBox/AgreeToCheckCreditCheckBox';
import { trackTransition } from '../../../../../framework/store/FPTI/FPTIActions';
import { spinnerOpen } from '../../../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import { submitApplication } from './PersonalInfoFormActions';
import { getInitialPersonalInfoValues } from '../../../../config/form';
import Col from '../../../../../shared-components/VXGrid/Col';
import Row from '../../../../../shared-components/VXGrid/Row';
import './PersonalInfoForm.less';
import _ from 'lodash';

const LOCALE_PREFIX_FULLNAME = 'DE/pages/PersonalInfoPage/FullName';
const LOCALE_PREFIX = 'DE/pages/PersonalInfoPage/PersonalInfoPage';

export class PersonalInfoForm extends Component {
    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        onFormSubmit: PropTypes.func.isRequired,
        intl: intlShape.isRequired,
        locale: PropTypes.string
    }

    componentDidMount() {
        setTimeout(() => {
            try {
                document.getElementById('userTitle').focus();
            } catch (err) {
                //no op
            }
        }, 100);
    }

    render() {
        const { handleSubmit, onFormSubmit, locale } = this.props;
        return (
            <Form id="personal-info-form" onSubmit={handleSubmit(onFormSubmit)} autoComplete="off">
                <div className="userTitleAndName">
                    <Row gutterSize={0}>
                        <Col xs={4} className="round-left">
                            <UserTitle />
                        </Col>
                        <Col xs={8} className="round-right">
                            <FullName localePrefix={LOCALE_PREFIX_FULLNAME} />
                        </Col>
                    </Row>
                </div>

                <Row gutterSize={0}>
                    <Col xs={12}>
                        <CollapsibleAddressFields />
                    </Col>
                </Row>
                <Row gutterSize={0}>
                    <Col xs={12}>
                        <BirthDate />
                    </Col>
                </Row>
                <Row gutterSize={0}>
                    <Col xs={12}>
                        <PhoneNumber />
                    </Col>
                </Row>
                <div className="agreeCreditCheck">
                    <Row gutterSize={0}>
                        <Col xs={12}>
                            <AgreeToCheckCreditCheckBox locale={locale} />
                        </Col>
                    </Row>
                </div>
            </Form>
        );
    }
}

export const mapStateToProps = state => {
    const initialValues = getInitialPersonalInfoValues(state);
    return {
        initialValues: Object.assign(initialValues, {
            telephone: ''
        }),
        formValues: _.get(state, `form.${FORM_ID}.values`),
        locale: _.get(state, 'serverData.locale.locale', 'de_DE')
    };
};

export const mapDispatchToProps = dispatch => ({
    // handleSubmit will call this function if field validation passes.
    // formValues are passed by handleSubmit per api specification
    onFormSubmit(formValues) {
        dispatch(trackTransition('apply_pp_credit_personalinfopage', 'process_apply_pp_credit_personalinfopage'));
        dispatch(spinnerOpen());
        dispatch(submitApplication(formValues, LOCALE_PREFIX));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(
    reduxForm({
        form: FORM_ID,
        destroyOnUnmount: false,
        forceUnregisteredOnUnmount: true
    })(PersonalInfoForm)
));
